<template>
    <div class="">
        <v-layout row v-if="error">
            <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>     
        <v-container fluid >
            <v-layout align-start>
                <v-flex xs12>
                    <v-card class="elevation-12">
                    <v-toolbar dark color="secondary">
                        <v-spacer></v-spacer>
                        <v-toolbar-title>Item Image Admin. (Total Image Count: {{totalImageRpt.totalImageCount}})</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <ctlItemAdvancedSearchFilter allowSearchNoParas="true" @onSearchParamsChanged="onSearchParamsChanged"></ctlItemAdvancedSearchFilter>
                    </v-card-text>
                    <v-card-text v-if="itemImages">
                        <v-layout row wrap>
                            <v-flex
                            v-for="img in itemImages" 
                            :key="img.id"
                            xs12
                            sm6
                            md4
                            lg3
                            d-flex
                            >
                            <v-card flat tile >
                                <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs12 >
                                                <v-img
                                                    :src="`${img.imageUrlW400}`"
                                                    height="200"
                                                    width="300"
                                                    aspect-ratio="1"
                                                    contain
                                                >
                                                </v-img>

                                        </v-flex>
                                        <v-flex xs12>
                                                {{img.itemNumber}}
                                        </v-flex>
                                        <v-flex xs12>
                                                {{img.itemDesc}}
                                        </v-flex>
                                    </v-layout>
                                    <ctlItemImageHideFromRoles
                                        :imageData="img"
                                        :allRoles="allRoles"
                                        @rolesChanged="searchItems">
                                    </ctlItemImageHideFromRoles>

                                </v-card-text>
                                
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                        <v-btn small color="warning" @click.prevent="onDeleteImg(img)">Delete This Image</v-btn>
                                    <v-spacer></v-spacer>

                                </v-card-actions>
                            </v-card>
                            </v-flex>
                        </v-layout>
                        <div class="text-xs-center">
                            <v-pagination
                            v-model="searchCriteria.page"
                            :length="pages"
                            circle
                            ></v-pagination>
                        </div>
                    </v-card-text>
                    <v-card-text v-else>
                        <v-layout row>
                            <v-alert value="true" color="warning" body-2 outline>No Image Found</v-alert>
                        </v-layout>
                    </v-card-text>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <!-- {{userData}} -->
    </div>


</template>
<script>
// import _ from 'lodash'
// import jobTypeApi from '@/api/jobTypeApi'
import ctlItemAdvancedSearchFilter from '@/components/ctlItemAdvancedSearchFilter'
import ctlItemImageHideFromRoles from '@/components/admin/ctlItemImageHideFromRoles'
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
    components: {
        'ctlItemAdvancedSearchFilter': ctlItemAdvancedSearchFilter,
        ctlItemImageHideFromRoles,
        },
    data: () => ({
        allRoles: [],
        searchCriteria: {
            page: 1,
            recordsPerPage: 12,
        },
        pages: null,
        itemImages: [],
        totalImageRpt: {}
    }),
    computed: {
        ...mapGetters('auth',[
            'loggedIn',
            'userData',
            'userHasPublicRole',
            'userHasInternalRole',
        ]),
        itemPicked(item) {
            //do nothing now
        },
        error () {
            return this.$store.getters.error
        },
        loading () {
            return this.$store.getters.loading
        }
    },
    watch: {
        searchCriteria: {
            handler: async function (newVal, oldVal) {
                console.log(`${newVal.page} === ${oldVal.page}`)
                // if page not changes, it means the search fired from other search filters
                // so I need reset page = 1
                if(oldVal && newVal.page === oldVal.page) {
                    // newVal.page = 1
                }
                await this.searchItems()
            },
            deep: true
        },
        userIsAuthenticated (value) {
            if (!value) {
                this.$router.push('/')
            }
        }
    },
    methods: {
        ...mapActions('adminItemImages',[
            'searchItemImageAdvanced',
            'deleteItemImage',
            'getTotalImageRpt'
        ]),
        ...mapActions('adminUser',[
            'getAllRoles',
        ]),
        async loadRoles() {
            this.allRoles = await this.getAllRoles()
        },
        async onSearchParamsChanged (paras) {
            this.searchCriteria = Object.assign({}, paras, {recordsPerPage: 12})    //hard set records to 12
            
        },
        async getTotalImageInfo () {
            const searchResult = await this.getTotalImageRpt()
            this.totalImageRpt = searchResult
        },
        async searchItems () {
            const searchResult = await this.searchItemImageAdvanced(this.searchCriteria)
            this.itemImages = searchResult.records
            this.pages = searchResult.pageCount
        },
        async onDeleteImg(img) {
            if(!confirm('Are you sure to delete this image?')){
                return
            }

            await this.deleteItemImage(img.id)
            this.searchItems()
            this.getTotalImageInfo()
        },
        onDismissed () {
            // console.log('onDismissed alert')
            // this.$store.dispatch('clearError')
        }
    },
    created: async function () {
        this.loadRoles()
        this.searchItems()
        this.getTotalImageInfo()
    },
    mounted: function () {

    },

    destroyed: function () {
        this.onDismissed()
    }
}
</script>